export default __webpack_public_path__ + "static/media/chioma.d7e2a87e.png";